<template>
    <div :id="id" 
        class="panel-group filter-box" 
        role="tablist" 
        aria-multiselectable="true">
        <span v-if="helpText" class="help-block">{{ helpText }}</span>
        <div class="panel panel-default">
            <div class="panel-heading">
                <h4 class="panel-title">
                    <a role="button" 
                        data-toggle="collapse" 
                        :data-parent="`#${id}`" 
                        :href="`#${id}-content`" 
                        :aria-expanded="open ? 'true' : 'false'" 
                        aria-controls="collapse">
                        {{ title }}
                    </a>
                </h4>
                <div class="panel-subtitle">
                    <slot name="subtitle"></slot>
                </div>
            </div>
            <div :id="`${id}-content`" 
                :class="{'panel-collapse': true, 'collapse': true, 'in': open}">
                <div class="panel-body">
                    <slot></slot>
                    <div v-if="!readonly" style="margin-top:15px;">
                        <div class="row col-md-10 col-xs-10">
                            <button class="btn btn-primary" 
                                type="button"
                                @click="onFilter">
                                <i :class="`fa fa-${submitIcon}`"></i>
                                {{ submitLabel }}
                            </button> 
                            <button class="btn btn-danger"
                                type="button"
                                @click="onReset">
                                <i class="fa fa-refresh"></i>
                                {{ resetLabel }}
                            </button>
                            <slot name="additional-actions"></slot>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        helpText: {
            type: String,
            required: false,
            default: '(*) Klik Filter untuk menampilkan opsi pencarian data pada tabel',
        },
        id: {
            type: String,
            required: false,
            default: 'filter-box-container',
        },
        onReset: {
            type: Function,
            required: false,
            default: () => {},
        },
        onFilter: {
            type: Function,
            required: false,
            default: () => {},
        },
        open: {
            type: Boolean,
            required: false,
            default: false,
        },
        readonly: {
            type: Boolean,
            required: false,
            default: false,
        },
        resetLabel: {
            type: String,
            required: false,
            default: 'Reset',
        },
        submitIcon: {
            type: String,
            required: false,
            default: 'filter',
        },
        submitLabel: {
            type: String,
            required: false,
            default: 'Filter',
        },
        title: {
            type: String,
            required: false,
            default: 'Filter',
        },
    }
}
</script>